import { Page, PageLink } from "@tfg/ui"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

export const SuppliersListWrapper = () => {
  const { t } = useTranslation("suppliers")

  const pages = useMemo<PageLink[]>(
    () => [
      {
        label: t("monitoring.title"),
        link: "monitoring",
      },
      {
        label: t("repository.title"),
        link: "repository",
      },
      {
        label: t("risk.title"),
        link: "risk",
      },
      {
        label: t("productionSites.title"),
        link: "productionSites",
      },
    ],
    [t]
  )

  return <Page title={t("title")} pages={pages} />
}
